import React from "react";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import { FOUNDERS } from "../lib/data";

export default function Founders() {
  return (
    <div data-testid="founders-page">
      <PageIntro
        label="Founders"
        titleLines={["The people", "behind every", "pincode."]}
      />

      <section className="px-5 md:px-10 py-8 md:py-16 space-y-20 md:space-y-32">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name}>
            <div
              data-testid={`founder-${i}`}
              className={`max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:[direction:ltr]" : ""}`}>
                <div className="overflow-hidden rounded-[2rem] rounded-tr-[6rem] h-96 md:h-[32rem]">
                  <img src={f.image} alt={f.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className={`md:col-span-6 md:col-start-7 ${i % 2 === 1 ? "md:[direction:ltr]" : ""}`}>
                <p className="font-mono text-xs uppercase tracking-[0.28em] text-brand-sprout mb-4">
                  {f.role}
                </p>
                <h2 className="font-serif font-light text-4xl md:text-5xl text-brand-ink leading-tight">
                  {f.name}
                </h2>
                <p className="mt-6 text-brand-muted leading-relaxed text-base md:text-lg">{f.bio}</p>
                <blockquote className="mt-8 border-l-2 border-brand-sprout pl-6 font-serif italic text-2xl md:text-3xl text-brand-forest leading-snug">
                  “{f.quote}”
                </blockquote>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      {/* Why we do this */}
      <section className="px-5 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <div className="max-w-[1400px] mx-auto rounded-[2rem] bg-brand-dark text-brand-bg p-8 py-16 md:p-20 relative overflow-hidden">
            <div className="noise-overlay" />
            <div className="relative max-w-3xl">
              <p className="font-mono text-xs uppercase tracking-[0.28em] text-brand-sprout mb-6">
                Why we do this
              </p>
              <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl leading-tight">
                Fresh food loses its value in transit, and small entrepreneurs lose their margin to
                middlemen. 40X Leaves fixes both — greens grown minutes from your door, by a local
                partner who keeps the majority of every rupee.
              </h2>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
